import "./wallet.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import storage from "@utils/storage";
import BorrowerWallet from "./BorrowerWallet/BorrowerWallet";
import LenderWallet from "./LenderWallet/LenderWallet";

function Wallet() {
  const navigate = useNavigate();
  const Id = storage.getUser();
  const role = Id?.role;

  return (
    <>
      {role === "lender" && (
        <div className="dashboard-wrapper">
          <LenderWallet></LenderWallet>
        </div>
      )}

      {role === "borrower" && (
        <div className="dashboard-wrapper">
          <BorrowerWallet></BorrowerWallet>
        </div>
      )}

      {!role && (
        <div className="dashboard-wrapper">
          <h2>Loading...</h2>
        </div>
      )}
    </>
  );
}

export default Wallet;
